var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuManagedModeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04688 4.46875H4.8125V3.60938C4.8125 3.51433 4.73567 3.4375 4.64062 3.4375C4.54558 3.4375 4.46875 3.51433 4.46875 3.60938V4.46875H2.23438C2.13933 4.46875 2.0625 4.54558 2.0625 4.64062V5.67188C2.0625 5.76692 2.13933 5.84375 2.23438 5.84375C2.32942 5.84375 2.40625 5.76692 2.40625 5.67188V4.8125H6.875V5.67188C6.875 5.76692 6.95183 5.84375 7.04688 5.84375C7.14192 5.84375 7.21875 5.76692 7.21875 5.67188V4.64062C7.21875 4.54558 7.14192 4.46875 7.04688 4.46875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9375 6.35938C8.9375 6.26433 8.86067 6.1875 8.76562 6.1875H5.32812C5.23308 6.1875 5.15625 6.26433 5.15625 6.35938V8.25H8.9375V6.35938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.28125H8.59375C8.97291 9.28125 9.28125 8.97291 9.28125 8.59375H4.8125C4.8125 8.97291 5.12084 9.28125 5.5 9.28125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 6.35938C4.125 6.26433 4.04817 6.1875 3.95312 6.1875H0.515625C0.420578 6.1875 0.34375 6.26433 0.34375 6.35938V8.25H4.125V6.35938Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6875 9.28125H3.78125C4.16041 9.28125 4.46875 8.97291 4.46875 8.59375H0C0 8.97291 0.308344 9.28125 0.6875 9.28125Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55723 3.09375H3.49473C2.89455 3.09375 2.40625 2.60545 2.40625 2.00527C2.40625 1.45939 2.81016 1.00616 3.33455 0.928297C3.41241 0.403906 3.86564 0 4.41152 0C4.77898 0 5.11397 0.181156 5.31472 0.480734C5.39447 0.465953 5.47542 0.458391 5.55723 0.458391C6.28375 0.458391 6.875 1.0493 6.875 1.77598C6.875 2.50267 6.28375 3.09375 5.55723 3.09375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuManagedModeSelected);
export default __webpack_public_path__ + "static/media/Menu-ManagedMode-Selected.b7a3126460cb62de5385d86b48cbfe0c.svg";
export { ForwardRef as ReactComponent };